export default __webpack_public_path__ + "static/media/blessedsacrament.82b8d067.jpg";